import React, { useState } from "react";
import { button as Primary, a as PrimaryLink } from "./primary";
import { button as Secondary, a as SecondaryLink } from "./secondary";
import { button as Tertiary, a as TertiaryLink } from "./tertiary";
import { button as Text, a as Link, buttonLink as TextLink } from "./text";
import { button as Icon, a as IconLink } from "./icon";
import styled from "styled-components";

export enum ButtonType {
  primary,
  secondary,
  tertiary,
  text,
  icon,
  textLink,
}

export const ModalButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.deprecatedSpacing.component.six};
  button {
    margin-left: ${({ theme }) => theme.deprecatedSpacing.component.four};
  }
`;

export type ButtonState = "none" | "hover" | "pressed";

interface ButtonProps extends React.HTMLProps<HTMLButtonElement> {
  disabled?: boolean;
  buttonType?: ButtonType;
  destructiveAction?: boolean;
  href?: string;
  target?: string;
  dataAnalyticsId?: string;
}

export function Button({
  disabled = false,
  buttonType = ButtonType.primary,
  href = "",
  target = "",
  type,
  dataAnalyticsId,
  ...props
}: ButtonProps) {
  let Button = href.length ? PrimaryLink : Primary;

  switch (buttonType) {
    case ButtonType.primary:
      Button = href.length ? PrimaryLink : Primary;
      break;
    case ButtonType.secondary:
      // not sure why ts is fine with the primary and tertiary links but not the secondary
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      Button = href.length ? SecondaryLink : Secondary;
      break;
    case ButtonType.tertiary:
      Button = href.length ? TertiaryLink : Tertiary;
      break;
    case ButtonType.text:
      Button = href.length ? Link : Text;
      break;
    case ButtonType.icon:
      Button = href.length ? IconLink : Icon;
      break;
    case ButtonType.textLink:
      Button = TextLink;
      break;
  }
  const [buttonState, setButtonState] = useState<ButtonState>("none");
  return (
    // eslint-disable-next-line
    // @ts-ignore something's going on with styled components and react types playing together
    <Button
      // @TODO these state controls still need some work, but good enough for now
      onMouseEnter={() => setButtonState("hover")}
      onMouseLeave={() => setButtonState("none")}
      onMouseDown={() => setButtonState("pressed")}
      onMouseUp={() => setButtonState("none")}
      disabled={disabled}
      state={buttonState}
      type={!href.length && typeof type === "undefined" ? "button" : type}
      data-analytics-id={dataAnalyticsId}
      {...props}
      {...(href.length ? { href } : {})}
      {...(target.length ? { target } : {})}
    />
  );
}

export default Button;

export const InlineLinkTextAsButton = styled(Button)`
  text-transform: none;
  padding-left: 0;
  padding-right: 0;
  // This color is part of our new Theme suite cyan500, but this file is still using deprecated theme (app/javascript/components/styling/colors.ts)
  color: #0e7c86;
`;
